import { render, staticRenderFns } from "./AddSku.vue?vue&type=template&id=10daa3dc"
import script from "./AddSku.vue?vue&type=script&lang=js"
export * from "./AddSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports